




















import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Locale from "@/lib/locale";
import { Props, Data, Method, Computed } from "./types";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-paypal-iframe-wrapped-recaptcha",
  props: {
    paypalIframeProps: { default: () => undefined },
    reCaptchaKeys: { default: () => undefined },
    reCaptchaUrl: { default: "" },
    actionType: { default: window.location.pathname }
  },
  data() {
    return {
      showIframe: false,
      showCheck: false,
      v3Key: this.reCaptchaKeys ? this.reCaptchaKeys.v3Key : "",
      v2Key: this.reCaptchaKeys ? this.reCaptchaKeys.v2Key : ""
    };
  },
  mounted() {
    this.recaptcha();
  },
  computed: {
    ...mapState("google", ["isBot"])
  },
  methods: {
    ...mapActions("google", ["postGoogleReCaptcha"]),
    async recaptcha() {
      const script = document.createElement("script");
      script.src = `${this.reCaptchaUrl}?render=${
        this.v3Key
      }&hl=${Locale.getReCaptchaLocale()}`;
      script.onload = () => {
        grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute(this.v3Key, {
            action: this.actionType
          });

          await this.postGoogleReCaptcha({ token, version: "v3" });

          if (this.isBot) {
            this.showCheck = true;
            await this.renderV2ReCaptcha();
            return;
          }

          this.showIframe = true;
        });
      };
      document.body.appendChild(script);
    },
    renderV2ReCaptcha() {
      grecaptcha.enterprise.render("payReCaptchaV2", {
        sitekey: this.v2Key,
        callback: response => this.checkReCaptcha(response)
      });
    },
    async checkReCaptcha(token: string) {
      await this.postGoogleReCaptcha({ token, version: "v2" });
      this.showIframe = true;
    }
  }
});
